<template>
    <div>
        <div class="main">
            <img width="100%" height="327" src="icon/userIcon/signInbg.png" alt="">
            <div class="title">

                <div class="back">
                    <!-- <img width="22" height="22" src="icon/userIcon/task_back_icon.png" alt=""> -->
                </div>
                <div @click="showDrawer" style="float:right;" class="fn_signIn">
                    签到规则
                </div>
            </div>
<!--            <div class="me_integral" @click="$router.push('/integral')">-->
<!--                <span class="small_integral">我的学分:</span>-->
<!--                <span class="sum_integral">{{integralSum}}</span>-->
<!--                <img width="12" height="12" src="icon/userIcon/signIn_right_icon.png" alt="">-->
<!--            </div>-->
        </div>
        <sign-in-drawer @hidden="hiddenShow" v-show="isShow"></sign-in-drawer>
        <sign-in-list @isChange='getChild' :paramTaskValue="taskValue"></sign-in-list>

        <div class="centered" style="width: 94%" data-notice="广告分类：签到页">
            <adModule :type="adTypeEnum.SIGN_PAGE.code" version="4"/>
        </div>

        <sign-task :paramValue="childValue" @taskChange='getTaskChange'></sign-task>
        <div class="btm_tip">
            -如有疑问，请参考<span @click="showDrawer" style="color:#FF8337">签到规则</span>-
        </div>

    </div>
</template>
<script>
// modules
import signInDrawer from './signInComp/signInDrawer.vue';
import signInList from './signInComp/signInList.vue';
import signTask from './signInComp/signTask.vue';
import adModule from '@/components/ad/bannerModule2'

// config
import appConfig from '@/appConfig';

// data
import adTypeEnum from '@/components/ad/adTypeEnum';

// api
import requestManager from '@comp/platformApi/requestManager';

//util
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';

const config = {
    desc : ''
};


export default {
    name: 'signIn',
    // extends : shixunPagePart,
    components: {
        signInDrawer,signInList,signTask,
        adModule
    },

    data() {
        return {
            adTypeEnum : adTypeEnum,
            isShow: false,
            integralSum: 0,
            // enableDataList : true,
            // autoLoadDataList : true,
            // scrollToLoadNextPage:false,
            // apiConfig : config.apiConfig,

            title: '签到',

            childValue: '',
            taskValue: 'false',

        }
    },
    methods: {
        getChild(value) {
            if (value) {
                this.childValue = value;
            }
        },

        getTaskChange(value) {
            if (value) {
                this.taskValue = value;
            }
        },
        showDrawer() {
            this.isShow = true
        },
        hiddenShow() {
            this.isShow = false
        },
        setWechatShare: function () {
            let wechatShareOptions = {
                title: appHelper.getTitle(),
                desc: '',
                link: location.href,
                imgUrl: appHelper.getAppIcon() // 分享图标
            };
            wechatHelper.setShare(wechatShareOptions);
        },

        getData: function () {
            requestManager.request({
                url: '/portal/v4/user/center/userTotalIntegral'
            }, (error, result) => {

                if (error) {
                    appHelper.generalAjaxError(error);
                    return;
                }

                this.integralSum = result.data;
            });
        }

    },

    mounted() {

        this.getData();

        appHelper.setTitle(this.title);

        if (deviceHelper.isBrowser && browserHelper.isWechat) {
            this.setWechatShare();
        }
    },
    updated() {
        if (this.childValue === 'true' || this.taskValue === 'true') {
            this.getData();
        }
    }
}
</script>
<style lang="scss" scoped>

.main {
    width: 100%;
    height: 216px;
    position: relative;
}

.title {
    position: absolute;
    top: 0;
    left: 3%;
    width: 94%;
    height: 44px;
    text-align: center;
    line-height: 44px;
    .fn_signIn {

        font-size: 12px;
        font-weight: 400;
        color: #FFE4A1;

    }
}

.back {
    float: left;
    margin-top: 16px;
}

.me_integral {
    position: absolute;
    top: 144px;
    left: 6%;
    .small_integral {

        font-size: 9px;
        font-weight: 500;
        color: #FFFFFF;

        margin-right: 5px;
    }
    .sum_integral {

        font-size: 21px;
        font-weight: 500;
        color: #FFFFFF;

        margin-right: 5px;
    }
}

.btm_tip {
    width: 100%;
    padding: 48px 0;
    text-align: center;

    font-size: 11px;
    font-weight: 500;
    color: #464646;

}

</style>
